import { useStoreSystem } from "../../../../store";
import shallow from "zustand/shallow";
import React, { useEffect } from "react";

function useCategoryTypes() {
    const { originDecorCategory, currentOriginDecors } = useStoreSystem(
        (state) => ({
            originDecorCategory: state.originDecorCategory,
            currentOriginDecors: state.currentOriginDecors,
        }),
        shallow
    );
    const types = currentOriginDecors
        .map((decor) => ({
            id: decor.TYPE_MODEL.CODE,
            name: decor.TYPE_MODEL.NAME,
        }))
        .filter((decor1, index, allDecors) => {
            return allDecors.findIndex((decor2) => decor2.name === decor1.name) === index;
        });

    const [selectedTypes, setSelectedTypes] = React.useState<string[]>(types.map(({ id }) => id));
    const handleChangeTypes = React.useCallback(
        (event: React.MouseEvent<HTMLElement>, newTypes: string[]) => {
            setSelectedTypes(newTypes);
        },
        [originDecorCategory]
    );

    useEffect(() => {
        setSelectedTypes(types.map(({ id }) => id));
    }, [originDecorCategory]);

    return {
        types,
        selectedTypes,
        handleChangeTypes,
    };
}

export default useCategoryTypes;
